module.exports = __webpack_public_path__ + "media/images/menu/btn-menu-mobile-cea4b99dcd25944d1cceb5a836275b94.png";